import { Injectable, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FieldErrorTimeoutService {
  private startedAt = Date.now();

  constructor() {
    inject(Router).events
      .pipe(filter((event): event is NavigationStart => event instanceof NavigationStart))
      .subscribe(() => {
        this.startedAt = Date.now();
      });
  }

  delayMs(timeoutSeconds: number): number {
    const windowMs = Math.max(0, timeoutSeconds) * 1000;
    const remaining = windowMs - (Date.now() - this.startedAt);
    return remaining > 0 ? remaining : windowMs;
  }
}
